import { useEffect, useRef } from "react";
import Lenis from "lenis";

/**
 * Mounts a Lenis instance for smooth momentum scrolling and returns the ref.
 * Hooks into window.scrollTo / requestAnimationFrame.
 */
export default function useLenis() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });
    lenisRef.current = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Hijack in-page anchor clicks so scroll-into-view respects Lenis
    const anchorClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href").slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -24, duration: 1.4 });
    };
    document.addEventListener("click", anchorClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", anchorClick);
      lenis.destroy();
    };
  }, []);

  return lenisRef;
}
